import actionTypes from '../constants/action-types';

const socialIcons = (state = {}, action) => {
  if (action.type !== actionTypes.SET_SOCIAL_ICONS) return state;
  return action.payload.socialIcons;
};

export default socialIcons;
